import { getShellLogger } from './logger'

let chameleonVersion = '0.0.0-development-SNAPSHOT'

export const setChameleonWebVersion = (version: string | null) => {
  if (version) {
    chameleonVersion = version
  }
  getShellLogger().log(`Chameleon version: ${version}`)
}

export const getChameleonWebVersion = () => chameleonVersion
